// extracted by mini-css-extract-plugin
export default {"price":"V4-z","onSale":"W4-z","msrpLabelPrice":"X4-z","msrpLabel":"Y4-z","originalPrice":"Z4-z","percentOff":"_4-z"};